<template>
    <div>
		<!-- <sice-provider :mock-data="{ isApp: true, isLogin: false, openLog: true}"> -->

        <div id="top"></div>

        <!-- header -->
        <header-area :active-number="3"></header-area>

        <!-- main -->
        <article class="main">

            <div class="container">
                <h1 class="tit-type1" title="Fund Talks 揪團聽講座">
                    <span class="focus">
                        Fund Talks 揪團聽講座
                    </span>
                </h1>
                <section class="item blockStyle">
                    <div class="item2 lastItem">
                        <p class="tit-type2">
                            <strong>歡迎預約Fund Talks 揪團聽講座，您所預約的主題為：<span class="focusText">{{ themeTitle }}</span></strong>
                            <!--
                            <el-button 
                                type="primary"
                                class="sBtn"
                                round
                                plain
                                @click.prevent="$router.push('/')"
                            >
                                變更講座主題
                            </el-button>
                            -->
                        </p>
                        <el-alert
                            title="資深投資顧問透過面對面輕鬆對談、您問我答，完整梳理您的理財需求，提供量身訂做基金投資解方！"
                            type="success"
                            :closable="false"
                            >
                        </el-alert>
                        <el-divider><i class="el-icon-more"></i></el-divider>
                        <el-form :model="demo" ref="demo" label-position="top" class="demo-ruleForm">
                            <p class="tit-type2">
                                <strong class="focusText">聯絡窗口</strong>
                            </p>
                            <div class="form-area">
                                <div class="form-item">
                                    <div class="form-item-tit">
                                        姓名
                                    </div>
                                    <div class="form-item-input">
                                        <el-form-item
                                            prop="member.name"
                                            :rules="[
                                                { validator: isChinese }
                                            ]"
                                        >
                                            <el-input
                                                placeholder="例：王小明"
                                                v-model="demo.member.name"
                                            >
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-item">
                                    <div class="form-item-tit">
                                        性別
                                    </div>
                                    <div class="form-item-input">
                                        <el-form-item
                                            prop="member.gender"
                                            :rules="[ 
                                                { required: true, message: '請選擇性別' }
                                            ]"
                                        >
                                            <el-radio-group v-model="demo.member.gender">
                                                <el-radio :label="49" border>男</el-radio>
                                                <el-radio :label="50" border>女</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-item">
                                    <div class="form-item-tit">
                                        手機號碼
                                    </div>
                                    <div class="form-item-input">
                                        <el-form-item
                                            prop="member.phone"
                                            :rules="[
                                                { validator: isCellPhone }
                                            ]"
                                        >
                                            <el-input
                                                class="hide-spin-button"
                                                type="tel"
                                                maxlength="10"
                                                placeholder="範例：0932885888"
                                                @input="(e) => stringFilter(e, demo.member, 'phone')"
                                                v-model="demo.member.phone"
                                            >
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-item">
                                    <div class="form-item-tit">
                                        室內電話 <span class="remark">(此項非必填)</span>
                                    </div>
                                    <div class="form-item-input">
                                        <el-row :gutter="10">
                                            <el-col :span="6">
                                                <el-form-item
                                                    prop="member.morning.area"
                                                >
                                                    <el-input
                                                        class="hide-spin-button"
                                                        type="tel"
                                                        maxlength="2"
                                                        placeholder="區碼"
                                                        @input="(e) => stringFilter(e, demo.member.morning, 'area')"
                                                        v-model="demo.member.morning.area"
                                                    >
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item
                                                    prop="member.morning.tel"
                                                >
                                                    <el-input
                                                        class="hide-spin-button"
                                                        type="tel"
                                                        maxlength="8"
                                                        placeholder="電話號碼"
                                                        @input="(e) => stringFilter(e, demo.member.morning, 'tel')"
                                                        v-model="demo.member.morning.tel"
                                                    >
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-form-item
                                                    prop="member.morning.ext"
                                                >
                                                    <el-input placeholder="分機" v-model="demo.member.morning.ext"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                                <div class="form-item full">
                                    <div class="form-item-tit">
                                        Email
                                    </div>
                                    <div class="form-item-input">
                                        <el-form-item
                                            prop="member.email"
                                            :rules="[
                                                {type: 'email', required: true, message: '請確認信箱資料之正確性'}
                                            ]"
                                        >
                                            <el-input v-model="demo.member.email" type="email"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-item full">
                                    <div class="form-item-tit">
                                        個人資料同意條款
                                    </div>
                                    <div class="form-item-input">
                                        <el-form-item
                                            prop="member.agree"
                                            :rules="[
                                                { required: true, message: '請閱讀並勾選同意條款'}
                                            ]"
                                        >
                                            <el-checkbox
                                                v-model="demo.member.agree"
                                                name="member.agree"
                                                true-label="Y"
                                            >
                                                我已閱讀並同意接受 <a href="https://www.franklin.com.tw/Privacy" target="_blank" class="link">「富蘭克林證券投顧 個人資料告知義務內容」</a>
                                            </el-checkbox>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <el-divider><i class="el-icon-more"></i></el-divider>
                            <p class="tit-type2">
                                <strong class="focusText">預約講座資訊</strong>
                            </p>
                            <div class="form-area">
                                <div class="form-item full" v-if="isCustomTheme">
                                    <div class="form-item-tit">
                                        希望舉辦主題
                                    </div>
                                    <div class="form-item-input">
                                        <el-form-item
                                            prop="seminar.theme"
                                            :rules="[
                                                { required: true, message: '請輸入希望舉辦主題'}
                                            ]"
                                        >
                                            <el-input
                                                v-model="demo.seminar.theme"
                                                placeholder="請填寫希望舉辦的主題"
                                                maxlength="50"
                                            >
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                    <el-alert
                                        description="註：自訂主題將由專人與您連絡討論"
                                        type="warning"
                                        :closable="false"
                                        show-icon>
                                    </el-alert>
                                </div>
                                <div class="form-item">
                                    <div class="form-item-tit">
                                        希望舉辦日期
                                    </div>
                                    <div class="form-item-input">
                                        <el-form-item
                                            prop="seminar.date"
                                            :rules="[
                                                { required: true, message: '請選擇日期' }
                                            ]"
                                        >
                                            <el-date-picker
                                                v-model="demo.seminar.date"
                                                type="date"
                                                :editable="false"
                                                :picker-options="{ 
                                                    disabledDate: calendarFilter
                                                }"
                                                @blur="workDayCounter = 1"
                                            >
                                            </el-date-picker>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-item">
                                    <div class="form-item-tit">
                                        希望舉辦時段
                                    </div>
                                    <div class="form-item-input">
                                        <el-form-item
                                            prop="seminar.timePeriodValue"
                                            :rules="[
                                                { required: true, message: '請選擇時段'}
                                            ]"
                                        >
                                            <el-select v-model="demo.seminar.timePeriodValue" filterable placeholder="請選擇">
                                                <el-option
                                                    v-for="item in demo.seminar.timePeriod"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-item full">
                                    <div class="form-item-tit">
                                        預計上課地點
                                    </div>
                                    <div class="form-item-input">
                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item
                                                    prop="seminar.address.location"
                                                    :rules="[
                                                        {required: true, message: '請至少選擇一個地點'}
                                                    ]"
                                                >
                                                    <el-radio-group 
                                                        v-model="demo.seminar.address.location" 
                                                    >
                                                        <el-radio :label="0">線上開講</el-radio>
                                                        <el-radio :label="1">自行提供(例:貴公司會議室)</el-radio>
                                                        <template v-for="(office, index) in franklinOffice">
                                                            <span :key="index">
                                                                <br v-if="windowWidth < 768" />
                                                                <el-radio :label="office.id">{{ office.name }}</el-radio>
                                                                <el-tooltip effect="dark" :content="office.address" placement="top">
                                                                    <i class="el-icon-info specialRadioAfterIcon"></i>
                                                                </el-tooltip>
                                                            </span>                                                            
                                                        </template>

                                                        <br v-if="windowWidth < 768" />
                                                        <el-radio :label="5">其他</el-radio>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <transition name="el-fade-in-linear">
                                            <el-row class="margin-top-10" :gutter="10" v-if="isCustomLocation">
                                                <el-col :span="24" class="margin-bottom-15">
                                                    <el-form-item
                                                        prop="seminar.address.location2"
                                                        :rules="[
                                                            { required: true, message: '請輸入上課地點' }
                                                        ]"
                                                    >
                                                        <el-input
                                                            type="text"
                                                            v-model="demo.seminar.address.location2"
                                                            class="margin-top-sm-10"
                                                            placeholder="上課地點"
                                                        >
                                                        </el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :sm="5" :xs="12">
                                                    <el-form-item
                                                        prop="seminar.address.cityValue"
                                                        :rules="[
                                                            { required: true, message: '請選擇鄉鎮市區'}
                                                        ]"
                                                    >
                                                        <el-select v-model="demo.seminar.address.cityValue" filterable placeholder="請選擇">
                                                            <el-option
                                                                v-for="(item, index) in cityList"
                                                                :key="index"
                                                                :label="item"
                                                                :value="item">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :sm="5" :xs="12">
                                                    <el-form-item
                                                        prop="seminar.address.districtValue"
                                                        :rules="[
                                                            { required: true, message: '請選擇鄉鎮市區'}
                                                        ]"
                                                    >
                                                        <el-select v-model="demo.seminar.address.districtValue" filterable placeholder="請選擇">
                                                            <el-option
                                                                v-for="(item, index) in districtList"
                                                                :key="index"
                                                                :label="item"
                                                                :value="item">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :sm="14" :xs="24">
                                                    <el-form-item
                                                        prop="seminar.address.addr"
                                                        :rules="[
                                                            { required: true, message: '請輸入地址'}
                                                        ]"
                                                    >
                                                        <el-input v-model="demo.seminar.address.addr" class="margin-top-sm-10"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </transition>
                                    </div>
                                </div>
                                <div class="form-item">
                                    <div class="form-item-tit">
                                        預計上課人數 <span class="remark">(至少8人)</span>
                                    </div>
                                    <div class="form-item-input">
                                        <el-input-number v-model="demo.seminar.quantity" :min="8" label="預計上課人數"></el-input-number>
                                        <span style="font-size: 16px;">&nbsp;人</span>
                                    </div>
                                </div>
                                
                            </div>
                        </el-form>
                        <el-alert
                            description="註：若您人數未達8人，敬請您來電:0800-885-888 由專人為您服務"
                            type="warning"
                            :closable="false"
                            show-icon>
                        </el-alert>
                        <div class="btnArea twoBtn">
                            <el-button
                                round
                                type="primary"
                                style="min-width: 250px; text-align: center;"
                                @click="confirmAppointment"
                            >
                                確認送出<i class="el-icon-caret-right el-icon--right"></i>
                            </el-button>
                            <el-button
                                round
                                plain
                                style="min-width: 250px; text-align: center;"
                                @click="resetForm"
                            >
                                清除重填<i class="el-icon-refresh-left el-icon--right"></i>
                            </el-button>
                        </div>
                    </div>
                </section>
            </div>

        </article>

        <!-- footer -->
        <footer-area></footer-area>

    </div>
</template>

<script>
import HeaderArea from "@/components/HeaderArea.vue";
import FooterArea from "@/components/FooterArea.vue";
import Area from "@/assets/area/area.js";
import holiday from "@/assets/holiday/holiday.js";

export default {
    components: {
        HeaderArea,
        FooterArea
    },
    data() {
        return {
            windowWidth: $(window).innerWidth(),
            demo: {
                member: {
                    name: '',
                    gender: null,
                    phone: '',
                    morning: {
                        area: '',
                        tel: '',
                        ext: '',
                    },
                    email: '',
                    agree: '',
                },
                seminar: {
                    theme: '',
                    date: '',
                    timePeriod: [
                        {
                            value: '1',
                            label: '09:00 ~ 12:00',
                        },
                        {
                            value: '2',
                            label: '12:00 ~ 18:00',
                        },
                        {
                            value: '3',
                            label: '18:00 ~ 20:00',
                        }
                    ],
                    timePeriodValue: '',
                    address: {
                        cityValue: '臺北市',
                        districtValue: '',
                        addr: '',
                        location: '',
                        location2: '' //自訂輸入地點
                    },
                    quantity: '',
                },
            },
            franklinOffice: [
                {
                    id: 2,
                    name: "富蘭克林台北辦公室",
                    address: "台北市忠孝東路四段87號5樓"
                },
                {
                    id: 3,
                    name: "富蘭克林台中辦公室",
                    address: "台中市文心路四段208-1號8樓-1"
                },
                {
                    id: 4,
                    name: "富蘭克林高雄辦公室",
                    address: "高雄市苓雅區海邊路31號17樓-3"
                }
            ],
            workDayCounter: 1,
            workDaySave: []
        }
    },
    methods: {
        //清除於電話欄位中輸入的一般文字
        stringFilter(str, ref, target) {
            let num = parseInt(str, 10);
            let isNumber = isNaN(num);
            if (isNumber) {
                ref[target] = str.slice(0, str.length-1);
            }
        },
        //驗證並送出表單
        confirmAppointment() {
            this.$refs["demo"].validate(valid => {
                if (valid) {
                    let form = this.compositForm(); //組成並取得表單
                    this.sendForm(form); //送出表單
                } else {
                    this.$message.error({
                        dangerouslyUseHTMLString: true,
                        message: `<strong>預約失敗，請確保資料皆已填妥</strong>`
                    })
                }
            })
        },
        //送出表單
        sendForm(data) {
            //Json to FormData
            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key]);
            }
            //Call API
            let apiLoc = this.isTestEnv ? "wt" : "www"; //API位置
            const api = `https://${apiLoc}.franklin.com.tw/FAPI/wf04/dowf04`;
            this.axios.post(api, form_data).then(res => {
                if (res.status === 200 && res.data.result === "success") {
                    this.$message({
                        type: 'success',
                        showClose: true,
                        duration: 0, //
                        dangerouslyUseHTMLString: true,
                        message: `<p>我們已收到您的報名，近日將有專人與您電話聯絡講座細節，敬請留意！</p>
                                  <p>若有任何問題，請來電0800-885-888轉接專人為您服務，謝謝。</p>
                                    `
                    });
                    this.resetForm(); //重設表單
                } else {
                    this.$message.error({
                        dangerouslyUseHTMLString: true,
                        message: `<strong>${res.data.message}</strong>`
                    })
                }
            })
            .catch(error => {
                this.$message.error({
                    dangerouslyUseHTMLString: true,
                    message: `<strong>資料回傳發生錯誤，請撥客服電話</strong>`
                })
            })
        },
        //組織表單資料
        compositForm() {
            const { name, gender, phone, email, agree, morning: telephone } = this.demo.member;
            const { theme, date, quantity, timePeriodValue } = this.demo.seminar;

            //自訂地點或是富蘭克林的辦公室資料
            const office = this.officeData(this.demo.seminar.address);

            const vm = this;
            //組合用戶表單
            let Form = {
                Event_Id: "C0276",
                Friend_Name: name,
                Sex: gender, // male:49, female:50
                M_Tel: phone, //手機
                O_Tel: vm.phoneFormat(telephone), //(02)2258-6682 Ext:360
                Email: email,
                isAgree: agree, // Y or N 
                Memo: theme || `${vm.themeTitle}`, // 演講主題
                address_location: `${office.name}`, //地點名稱
                Address: office.address, //詳細地址
                Join_Count: quantity, //人數
                SeminarDate: vm.dateForm(date), //yyyy/mm/dd
                timePeriodValue: timePeriodValue
            }

            return Form;
        },
        //電話格式 02-22813365#886
        phoneFormat({ area, tel, ext }) {
            area = area? `${area}-` : '';
            tel = tel? tel.slice(0, 4) + tel.slice(4 + Math.abs(0)) : '';
            ext = ext? `#${ext}`: '';

            return `${area}${tel}${ext}`;
        },
        //驗證手機格式
        isCellPhone(_, value, callback) {
            var MobileReg = /^(09)[0-9]{8}$/;
            if (value === '') {
                callback(new Error("請輸入手機號碼"))
            } else if (!MobileReg.test(value)) {
                callback(new Error("手機格式錯誤"))
            } else {
                callback()
            }
        },
        //是否為中文
        isChinese(_, value, callback) {
            var regx = /[^\u4e00-\u9fa5]/;
            if (value === '') {
                callback(new Error("請輸入姓名"))
            } else if (regx.test(value)) {
                callback(new Error("請輸入中文"))
            } else {
                callback()
            }
        },
        //過濾掉月曆中的不可選日期
        calendarFilter(date) {
            //timestamp
            let now = new Date().getTime(); //今天
            let time = date.getTime(); //日曆中的日期
            let isWeekend = date.getDay() === 0 || date.getDay() === 6? true : false;
            let isNextYear = date.getFullYear() > 2021;
            let isHoliday = holiday().find(item => {
                return new Date(item.date).getTime() === time
            });
            //filter
            if (now > time) return true  //已經過去的日期
            else if (isWeekend && isNextYear) return true //周末 --禁用        
            else if (isHoliday) return true //國定假日 --禁用
            //T+7
            else if (this.workDayCounter < 7) {
                this.workDayCounter += 1;
                this.workDaySave.push(time); //save workday
                return true
            }
            else if (this.workDaySave.includes(time)) return true
            //other days
            else return false;
        },
        //轉換日期格式 yyyy/mm/dd
        dateForm(date) {
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();

            let dateForm = `${year}/${month}/${day}`; //yyyy/mm/dd
            return dateForm;
        },
        //判斷為自訂地點或是富蘭克林的辦公室並回傳資料
        officeData({cityValue, districtValue, addr, location: officeId, location2: detailLoc}) {
            const office = this.franklinOffice.find(item => item.id === officeId) ||
            {
                name: detailLoc,
                address: cityValue + districtValue + addr //詳細地點
            }

            return office;
        },
        //清除表單
        resetForm() {
            this.$refs["demo"].resetFields();
        },
        //捲動至頂部
        scrollToTop() {
            window.scrollTo(0,0);
        }
    },
    computed: {
        //講座標題
        themeTitle() {
            let theme = JSON.parse(localStorage.getItem("seminarTitle")).theme;
            return this.$route.params.title || theme;
        },
        //縣市資料
        cityList() {
            return Object.keys(Area);
        },
        //縣市地區資料
        districtList() {
            let city = this.demo.seminar.address.cityValue;
            return Area[city];
        },
        //是否自訂開會地點
        isCustomLocation() {
            let location = this.demo.seminar.address.location;
            return location === 1 || location === 5;
        },
        //是否為自訂主題
        isCustomTheme() {
            let isCustom = JSON.parse(localStorage.getItem("seminarTitle")).isCustom;
            return this.$route.params.isCustom || isCustom;
        },
        //是否為測試環境或是其他環境
        isTestEnv() {
            let hostStringList = window.location.host.split("."); // wt.franklin.com
            return hostStringList[0] !== "www";
        }
    },
    mounted() {
      this.scrollToTop(); //捲至頂部
    }
}
</script>

<style scope>
    .el-picker-panel {
        color: #495057 !important;
    }
    .el-date-table th {
        color: #495057 !important;
    }
    .next-month {
        display: none !important;
    }
    .next-month.disabled div {
        display: none !important;
    }
</style>